import type {CustomCopilotId} from '../utils/copilot-chat-types'
import {useChatState} from '../utils/CopilotChatContext'
import {useChatManager} from '../utils/CopilotChatManagerContext'
import {customCopilotIdFromThread, useRouteSpaceId} from '../utils/custom-copilots-helpers'

/**
 * Pulls the selected custom copilot (space) from either the URL or the selected thread per the chat state.
 */
export function useSelectedCustomCopilotId(): CustomCopilotId | null {
  const manager = useChatManager()
  const state = useChatState()
  return useRouteSpaceId() || customCopilotIdFromThread(manager.getSelectedThread(state))
}
